import MarkdownIt from 'markdown-it'
import HtmlizedText from './HtmlizedText';

export default class Htmlizer {

    private markdownParser!: MarkdownIt;

    constructor() {
        this.markdownParser = new MarkdownIt({
            html: true,
            breaks: true
        });
    }

    public htmlize(text: string): string {
        const htmlizedText = new HtmlizedText(text);
        htmlizedText.htmlize(this.markdownParser);
        htmlizedText.removeEnclosingParagraph();
        return htmlizedText.getMe();
    }
}